import React, { Component } from 'react';

import _isEmpty from 'lodash.isempty';

import Popover from 'react-popover';
import { EditorState } from 'draft-js';
import cx from 'classnames';
import { Button, Icon, Text } from '../../../../../../../ui-kit';

import CommentTextEditor, { getContentState } from '../../CommentTextEditor';
import { getCurrentUserId } from '../../../../../../../common/utils';

import '../styles/_add-comment.scss';


























class AddComment extends Component {
  popoverRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      editorState: EditorState.createEmpty(),
      busy: false,
      assetIds: [],
      popoverParent: document.body
    };
  }

  componentDidMount() {
    this.setState({ popoverParent: this.popoverRef.current || document.body });
  }

  handleUpdateContent = (editorState) => {this.setState({ editorState });};

  handleFilesChange = (assetIds) => {this.setState({ assetIds });};

  getMetadata = () => {
    const { metadata, filterByMetadataFlag } = this.props;

    if (filterByMetadataFlag === void 0) {return JSON.stringify(metadata);}

    return JSON.stringify({
      ...metadata,
      ...filterByMetadataFlag
    });
  };

  handleSave = async () => {
    const { closePopover, createComment, onAddComment, shotId, sceneId } = this.props;

    const { editorState, assetIds } = this.state;
    const { json, plainText } = getContentState(editorState);

    if (!plainText.trim()) {return;}

    this.setState({ busy: true });

    const { data, error } = await createComment(
      { input: { content: json, metadata: this.getMetadata(), assetIds, shotId, sceneId } }
    );

    this.setState({ busy: false });

    if (!data || error) {return;}

    if (onAddComment) {
      onAddComment(data);
    }

    closePopover();
  };

  renderHeader = () => {
    const { closePopover, getTitle } = this.props;

    return (
      <div className="comment-popover__header">
        <Text heading3 noMargin="top">Add Comment</Text>
        {getTitle ? <Text heading5>{getTitle()}</Text> : null}
        <Icon
          clickable
          className="comment-popover__close-icon"
          name="close"
          onClick={closePopover}
          color="regent"
          hoverColor="black"
          size={15} />

      </div>);

  };

  renderBody = () => {
    const { resourceOrganisationId, onInputFocus } = this.props;
    const { editorState, assetIds } = this.state;

    const hasCurrentUserId = !_isEmpty(getCurrentUserId());

    return (
      <div className="comment-popover__body">
        <CommentTextEditor
          placeholder="Enter comment"
          editorState={editorState}
          onUpdateContent={this.handleUpdateContent}
          onSave={this.handleSave}
          assetIds={assetIds}
          onFilesChange={this.handleFilesChange}
          organisationId={resourceOrganisationId}
          canAddAsset
          canDeleteAsset
          onFocus={onInputFocus}
          setFocusOnMount={hasCurrentUserId} />

      </div>);

  };

  renderFooter = () => {
    const { editorState, busy } = this.state;
    const { plainText } = getContentState(editorState);

    return (
      <div className="comment-popover__footer">
        <Button
          onClick={this.handleSave}
          type="SECONDARY"
          busy={busy}
          disabled={!plainText.trim()}>

          Add Comment
        </Button>
      </div>);

  };

  renderContent = () =>
  <div className="comment-popover__container">
      {this.renderHeader()}
      {this.renderBody()}
      {this.renderFooter()}
    </div>;


  render() {
    const { children, closePopover } = this.props;
    const { popoverParent } = this.state;

    return (
      <div className="comment-popover__parent" ref={this.popoverRef}>
        <Popover
          {...this.props}
          key={this.popoverRef.current ? 'ready' : 'not-ready'}
          isOpen
          preferPlace="right"
          enterExitTransitionDurationMs={0}
          body={this.renderContent()}
          tipSize={0.01}
          onOuterAction={closePopover}
          className={cx('comment-popover', 'add-comment')}
          appendTarget={popoverParent}>

          {children}
        </Popover>
      </div>);

  }
}

export default AddComment;